import CommonService from '../../services/CommonService'

const ReviewComponent = (props) => {
  const { markRoosLocalObligDetails, contact, issuanceDetail, issueComments } = props;

  return (
    <>
      <html lang="en">
        <head>
          <meta charset="UTF-8"></meta>
          <style>
            {
              "\
               div.repeat-header {\
                 padding-top: 0.1in !important;\
                 display: block !important;\
                 text-align: center;\
                 position: running(repeat-header) !important;\
               }\
               .report-header {\
                   text-align: center;\
                   padding: 5px;\
                   width: 100%;\
                   height: 40px;\
                   table-layout:fixed;\
                   border-collapse: collapse;\
            }\
               .report-heading-left {\
                   font-size: 18px;\
                   font-weight: 800;\
                   color: darkblue;\
                   text-align: left;\
                   width: 20%;\
             }\
               .report-heading-left figure {\
                   margin: 0;\
                   padding: 0;\
            }\
            .report-heading-center {\
                   font-size: 12px;\
                   font-weight: 800;\
                   color: darkblue;\
                   text-align: center;\
                   width: 60%;\
                   white-space: normal;\
                   overflow-wrap: break-word;\
            }\
               .report-heading-right {\
                   font-size: 12px;\
                   font-weight: 800;\
                   color: darkblue;\
                   text-align: right;\
                   width: 20%;\
                   white-space: nowrap;\
            }\
              .report-heading-center h1, .report-heading-center p, .report-heading-right p {\
                   margin: 0;\
                   padding: 0;\
            }\
            .report-heading-title {\
                  font-size: 18px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: left;\
                  min-width: 65%;\
            }\
               .report-heading-date {\
                   font-size: 10px;\
                   font-weight: 800;\
                   color: darkblue;\
                   text-align: right;\
               }\
               div.footer {\
                 position: running(footer) !important;\
               }\
               #current-page-placeholder::before {\
                 content: counter(page);\
               }\
               #total-pages-placeholder::before {\
                 content: counter(pages);\
               }\
               @page {\
                   margin-top: 90px;\
                   @top-center {\
                       content: element(repeat-header) !important\
                   }\
               }\
               @page {\
                   @bottom-right {\
                       content: element(footer) !important;\
                       font-size: 10px;\
                   }\
               }\
               div.repeat-header table {\
                   page-break-inside: avoid;\
               }\
               div.repeat-header tr {\
                   page-break-inside: avoid;\
                   page-break-after: auto\
               }\
               div.repeat-header thead {\
                   display: table-header-group\
               }\
               div.repeat-header tfoot {\
                   display: table-footer-group\
               }\
               div.break-page {\
                   page-break-after: always;\
               }\
               .table a {\
                   color: black;\
                   text-decoration: underline;\
               }\
               .table .tableheader th, .table tbody th {\
                   color: #fff;\
                   background-color: darkblue;\
                   border-color: #454d55;\
                   vertical-align: middle;\
                   font-size: 1.0em;\
               }\
               .v-top {\
                   vertical-align: top !important;\
               }\
               tr {\
                   page-break-inside: avoid\
               }\
                h2.info-subsection, h2.sub-heading {\
                   font-size: 13px;\
                   font-weight: bold;\
                   text-align: left;\
                   vertical-align: bottom;\
              }\
               .invoice-box {\
                max-width: 800px;\
                margin: auto;\
                padding: 20px;\
                border: 1px solid #eee;\
                box-shadow: 0 0 10px rgba(0, 0, 0, .15);\
                font-size: 13px;\
                line-height: 18px;\
                font-family: Helvetica, Arial, sans-serif;\
                color: #555;\
             }\
               .invoice-box table {\
                 width: 100%;\
                 line-height: inherit;\
                 text-align: left;\
               }\
               .invoice-box table td {\
                 padding: 5px;\
                 vertical-align: top;\
               }\
             .border-top {\
                   border-top: 2px solid #eee;\
               }\
               .invoice-box table tr.top table td.title {\
                   font-size: 13px;\
                   line-height: 22px;\
                   color: #333;\
               }\
               .invoice-box table tr.information table td {\
                   padding-bottom: 10px;\
               }\
               .invoice-box table tr.heading td {\
                   border-bottom: 1px solid #ddd;\
                   font-weight: bold;\
               }\
               .invoice-box table tr.sub-heading td {\
                 font-weight: bold;\
               }\
               .invoice-box table tr.item td {\
                 border-bottom: 1px solid #eee;\
               }\
               .invoice-box table tr.item.last td {\
                   border-bottom: none;\
               }\
               .invoice-box table tr.total {\
                   border-top: 2px solid #eee;\
                   font-weight: bold;\
               }\
               .invoice-box table tr.section-title td {\
                 font-weight: bold;\
                 font-size: 18px;\
                 line-height: 18px;\
                 color: #000;\
               }\
               .invoice-box .information table tr th {\
                 padding-bottom: 10px;\
                 vertical-align: bottom;\
                 text-align: left;\
                 font-weight: normal;\
            }\
             .invoice-box .information table tr td {\
                 padding-bottom: 10px;\
                 vertical-align: bottom;\
             }\
            .information {\
              text-align: left;\
              padding-bottom: 20px;\
             }\
            .invoice-box .information .section-title {\
             font-weight: bold;\
             font-size: 18px;\
             line-height: 18px;\
             color: #000;\
             padding-bottom: 20px;\
            }\
            .info-subsection {\
             padding-bottom: 10px;\
            }\
            .invoice-box .information table.info-subsection caption {\
                    text-align: left;\
            }\
            .fs-12 {\
                    padding-bottom: 10px;\
            }\
            .invoice-box table tr.information table.data-table {\
                 border: 1px solid #ddd;\
            }\
            .invoice-box .information table.data-table {\
                border: 1px solid #ddd;\
            }\
            .invoice-box .information table.data-table tr.heading .th-left{\
                text-align: left;\
            }\
            .invoice-box .information table.data-table tr.heading .th-right {\
                text-align: right;\
            }\
            .invoice-box .information table.data-table th {\
                text-align: left;\
            }\
             .invoice-box .information table tr.heading th {\
                 border-bottom: 1px solid #ddd;\
                 font-weight: bold;\
                 vertical-align: bottom;\
                 text-align: left;\
            }\
             .invoice-box table tr.information th {\
                 padding-bottom: 10px;\
                 vertical-align: bottom;\
                 text-align: left;\
                 font-weight: normal;\
            }\
             .invoice-box table tr.information td {\
                 padding-bottom: 10px;\
                 vertical-align: bottom;\
             }\
               @media only screen and (max-width: 600px) {\
               .invoice-box table tr.top table td {\
                   width: 100%;\
                   display: block;\
                   text-align: center;\
               }\
               .invoice-box table tr.information table td {\
                   width: 100%;\
                   display: block;\
                   text-align: center;\
               }\
               }\
             "
            }
          </style>
        </head>
        <body className="pdf-box">
          <div className="invoice-box">
            <div><p className="fs-12"><i>Marks Roos Local Obligor Report Information as of Reporting Year End: <b>{CommonService.dateFormatter(markRoosLocalObligDetails.fiscalYrEndDate)}</b></i></p></div>
            <section className="information">
              <h1 className="section-title">Issuance</h1>
              <table>
                <tr><th>Issuer Name:</th><td align="right">{issuanceDetail.issuerName}</td></tr>
                <tr><th>Issue Name:</th><td align="right">{issuanceDetail.issueName}</td></tr>
                <tr><th>Project Name:</th><td align="right">{issuanceDetail.projectName}</td></tr>
                <tr><th>Date of Bond Issue/Loans:</th><td align="right">{CommonService.dateFormatter(issuanceDetail.actualSaleDate)}</td></tr>
                <tr><th>Settlement Date:</th><td align="right">{CommonService.dateFormatter(issuanceDetail.settlementDate)}</td></tr>
                <tr><th>Original Principal Amount:</th><td align="right">{CommonService.currencyFormatter(issuanceDetail.principalSaleAmt)}</td></tr>
                <tr><th>Date of Filing:</th><td align="right">{CommonService.dateFormatter(markRoosLocalObligDetails.filingDate)}</td></tr>
                <tr><th>Total Issuance Costs:</th><td align="right">{CommonService.currencyFormatter(markRoosLocalObligDetails.totalIssuanceCostAmt)}</td></tr>
                <tr><th>Total Cost of Issuance from Report of Final Sale:</th><td align="right">{CommonService.currencyFormatter(issuanceDetail.totalIssuanceAmt)}</td></tr>
                <tr><th>Name of Authority that purchased debt:</th><td align="right">{issuanceDetail.authorityName}</td></tr>
                <tr><th>Date of Authority Bond(s) Issuance:</th><td align="right">{CommonService.dateFormatter(issuanceDetail.settlementDate)}</td></tr>
                <tr><th>Total Costs of Issuance from Authority Report of Final Sale:</th><td align="right">{CommonService.currencyFormatter(issuanceDetail.authorityTotalIssuanceCost)}</td></tr>
                <tr><th>Is the Reserve Fund held at Authority level?:</th><td align="right">{markRoosLocalObligDetails.reserveMinBalInd ? (markRoosLocalObligDetails.reserveMinBalInd === "Y" ? "Yes" : "No") : ""}</td></tr>
                <tr><th>Reserve Fund Minimum Balance Amount:</th><td align="right">{CommonService.currencyFormatter(markRoosLocalObligDetails.reserveMinBalAmt)}</td></tr>
                <tr><th>Part of Authority Reserve Fund:</th><td align="right">{markRoosLocalObligDetails.authorityReserveFundInd ? (markRoosLocalObligDetails.authorityReserveFundInd === "Y" ? "Yes" : "No") : ""}</td></tr>
                <tr><th>Percent of Reserve Fund:</th><td align="right">{markRoosLocalObligDetails.percentReservedFund}</td></tr>
              </table>
            </section>

            <section className="information">
              <h1 className="section-title">Fund Balance</h1>
              <table>
                <tr><th>Principal Amount of Bonds Outstanding:</th><td align="right">{CommonService.currencyFormatter(markRoosLocalObligDetails.principalOutstdgAmt)}</td></tr>
                <tr><th>Bond Reserve Fund:</th><td align="right">{CommonService.currencyFormatter(markRoosLocalObligDetails.bondReserveFundAmt)}</td></tr>
                <tr><th>Capitalized Interest Fund:</th><td align="right">{CommonService.currencyFormatter(markRoosLocalObligDetails.capitalizedIntFundAmt)}</td></tr>
                <tr><th>Administrative Fee Charged by Authority:</th><td align="right">{CommonService.currencyFormatter(markRoosLocalObligDetails.adminFeeChargeAmt)}</td></tr>
              </table>
            </section>

            <section className="information">
              <h1 className="section-title">Delinquent Reporting</h1>
              <table>
                <tr><th>Have Delinquent Taxes been reported?</th><td align="right">{markRoosLocalObligDetails.dlqTaxIndicator}</td></tr>
                <tr><th>Delinquent Parcel Information Reported as of Equalized Tax Roll of:</th><td align="right">{CommonService.dateFormatter(markRoosLocalObligDetails.dlqParcelDate)}</td></tr>
                <tr><th>Delinquency Rate:</th><td align="right">{markRoosLocalObligDetails.dlqRate}</td></tr>
                <tr><th>Does this agency participate in the County’s Teeter Plan?</th><td align="right">{markRoosLocalObligDetails.teeterIndicator}</td></tr>
                <tr><th>Taxes Due:</th><td align="right">{CommonService.currencyFormatter(markRoosLocalObligDetails.dlqTaxDueAmt)}</td></tr>
                <tr><th>Taxes Unpaid:</th><td align="right">{CommonService.currencyFormatter(markRoosLocalObligDetails.dlqTaxUnpaidAmt)}</td></tr>
              </table>
            </section>

            <section className="information">
              <h1 className="section-title">Retired Issues</h1>
              <table>
                <tr><th>Indicate Reason for Retirement:</th><td align="right">{issuanceDetail.retireFlagDesc}</td></tr>
                {issuanceDetail.retireFlag === "R" && <>
                  <tr><th>CDIAC #:</th><td align="right">{issuanceDetail.redeemCDIACNumber}</td></tr>
                  <tr><th>Refunding Issue Name:</th><td align="right">{issuanceDetail.stateRefundingBondTitle}</td></tr>
                  <tr><th>Is the CDIAC mentioned correct?:</th><td align="right">{markRoosLocalObligDetails.correctCdiacNbrInd && (markRoosLocalObligDetails.correctCdiacNbrInd === "Y" ? "Yes" : "No")}</td></tr>
                  {markRoosLocalObligDetails.correctCdiacNbrInd && markRoosLocalObligDetails.correctCdiacNbrInd === "N" &&
                    <tr><th>Corrected CDIAC #:</th><td align="right">{markRoosLocalObligDetails.correctedRedeemCdiacNbr}</td></tr>}
                  <tr><th>Redemption Date:</th><td align="right">{CommonService.dateFormatter(issuanceDetail.retireDate)}</td></tr></>
                }
                {issuanceDetail.retireFlag === "M" && <>
                  <tr><th>Final Maturity Date:</th><td align="right">{CommonService.dateFormatter(issuanceDetail.retireDate)}</td></tr></>
                }
                {issuanceDetail.retireFlag === "O" && <>
                  <tr><th>Other Text:</th><td align="right">{issuanceDetail.otherRetireText}</td></tr>
                  <tr><th>Date:</th><td align="right">{CommonService.dateFormatter(issuanceDetail.retireDate)}</td></tr></>
                }
              </table>
            </section>

            <section className="information">
              <h1 className="section-title">Filing Contact</h1>
              <table>
                <tr><th>Filing Contact Name:</th><td align="right">{contact.contactFirstName} {contact.contactLastName}</td></tr>
                <tr><th>Agency/Organization Name:</th><td align="right">{contact.issuerName}</td></tr>
                <tr><th>Address:</th><td align="right">{contact.contactAddressLine1}</td></tr>
                <tr><th>City:</th><td align="right">{contact.contactCityName}</td></tr>
                <tr><th>State:</th><td align="right">{contact.contactStateCode}</td></tr>
                <tr><th>Zip Code:</th><td align="right">{contact.contactZipCode}</td></tr>
                <tr><th>Telephone:</th><td align="right">{contact.contactPhoneAreaCode + "-" + contact.contactPhoneNumber}</td></tr>
                <tr><th>Fax Number:</th><td align="right">{contact.contactFaxNumber}</td></tr>
                <tr><th>E-mail:</th><td align="right">{contact.contactEmailId}</td></tr>
              </table>
            </section>

            {/* Comments */}
            <section className="information">
              <h1 className="section-title">Comments</h1>
              <div>
                <table>
                  <tr><th>Issuer Comments:&nbsp;</th><td>{markRoosLocalObligDetails.issuerComment}</td></tr>
                </table>
              </div>
              <div>
                <h2 className="sub-heading">CDIAC Comments:</h2>
                <table>
                  <tr className="heading">
                    <th>Comment Type</th>
                    <th>Comment</th>
                    <th>Create User</th>
                    <th>Create Date </th>
                  </tr>
                  {issueComments.length > 0 ? issueComments.map((comment, i) => {
                    return (
                      <tr key={i}>
                        <td align="left">{comment.cdiacCodeValueDesc}</td>
                        <td align="left">{comment.comment}</td>
                        <td align="left">{comment.createUser}</td>
                        <td align="left">{CommonService.dateFormatter(comment.createDatetime)}</td>
                      </tr>
                    )
                  }) :
                    <tr><td colspan="4">No data available to disaplay.</td></tr>
                  }
                </table>
              </div>
            </section>

            <section>
              <table>
                {markRoosLocalObligDetails.statusFlag !== 'D' &&
                  <tr className="information">
                    <th>Submission Date:</th>
                    <td align="right">{CommonService.dateFormatter(markRoosLocalObligDetails.filingDate)}</td>
                  </tr>
                }
                {markRoosLocalObligDetails.statusFlag === 'R' &&
                  <tr className="information">
                    <th>Review Date:</th>
                    <td align="right">{CommonService.dateFormatter(markRoosLocalObligDetails.lastUpdateDatetime)}</td>
                  </tr>
                }
              </table>
            </section>
          </div>
        </body>
      </html>
    </>
  );

}
export default ReviewComponent;